/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP18_ANSWERS = [
    'Everybody is hiding behind boxes and cushions in the playroom.',
    'Tony wants to attack because Harry said Tony wasn’t cool.',
    'Harry wants to attack because Tony said science was boring.',
    'When Harry is about to charge again, Holly stops him because she doesn’t want to get her jacket dirty.',
    'Then, Tony stops the attack and thanks Stephanie for letting him stay with them.',
    'Next, Harry stops the attack because his shoelace is undone.',
    'Now Matt stops the attack because he needs to finish a level in his game.',
    'When Harry is about to charge again, Holly stops him because she doesn’t want to get her jacket dirty.',
    'Then Stephanie stops the attack because her nail polish needs to dry.',
    'Finally, everyone charges, and they have a huge pillow fight!',
    'Afterwards, Tony says Harry started it, but Harry says Tony started it.',
    'Harry and Tony start a pillow fight again!',
];

// export const HHT2_EP18_ANSWER_SOUNDS = [
//     '/HHT2_AB EP18_dyr01.mp3',
//     '/HHT2_AB EP18_dyr02.mp3',
//     '/HHT2_AB EP18_dyr03.mp3',
//     '/HHT2_AB EP18_dyr04.mp3',
//     '/HHT2_AB EP18_dyr05.mp3',
//     '/HHT2_AB EP18_dyr06.mp3',
//     '/HHT2_AB EP18_dyr07.mp3',
//     '/HHT2_AB EP18_dyr08.mp3',
//     '/HHT2_AB EP18_dyr09.mp3',
//     '/HHT2_AB EP18_dyr10.mp3',
//     '/HHT2_AB EP18_dyr11.mp3',
//     '/HHT2_AB EP18_dyr12.mp3',
// ];

export const HHT2_EP18_ANSWER_SOUNDS = [
    '/d0cd88318303f96f5241b753a1d0a369.mp3',
    '/827e910e3682b12179f1029859aa195e.mp3',
    '/e162def2d56fc9b4526bdea9b96c21df.mp3',
    '/c9b3b4ea0a99b49cc4593b6d84d5e6ad.mp3',
    '/29d08bf4978318410267cd838b557d31.mp3',
    '/d6fefa9815bef5188a95d76d15515466.mp3',
    '/57f202c52212968548c48eeaa91fb2cb.mp3',
    '/45b87af9ac788aa49444d2e0d7d142c0.mp3',
    '/a5b1eeee3b587135ec279ca6265d16f8.mp3',
    '/417f5fb93f703b56a403caefe92ccf7a.mp3',
    '/41b496b3b4207c697126dd4dbbd03d4e.mp3',
    '/c0baf4b9a1ba8453df22afc561298dfa.mp3',
];

export const HHT2_EP18_QUIZ_ITEMS = [{
    'A': HHT2_EP18_ANSWERS[6],
    'B': HHT2_EP18_ANSWERS[1],
    'SoundIndexA': 6,
    'SoundIndexB': 1,
    'answer': HHT2_EP18_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP18_ANSWERS[10],
        'B': HHT2_EP18_ANSWERS[4],
        'SoundIndexA': 10,
        'SoundIndexB': 4,
        'answer': HHT2_EP18_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP18_ANSWERS[7],
        'B': HHT2_EP18_ANSWERS[0],
        'SoundIndexA': 7,
        'SoundIndexB': 0,
        'answer': HHT2_EP18_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP18_ANSWERS[9],
        'B': HHT2_EP18_ANSWERS[2],
        'SoundIndexA': 9,
        'SoundIndexB': 2,
        'answer': HHT2_EP18_ANSWERS[9],
        'sound': [10, 11],
        'exception': false,
    },
]
